module.exports = __webpack_public_path__ + "img/arrow_left_2.76715729.svg";